export const GAD7_FORM_TITLE = "GAD-7";

export const PHQ9_FORM_TITLE = "PHQ-9";

export const EPDS_FORM_TITLE = "EPDS";
